import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import normalizeFolder from 'folders/util/normalizeFolder';
import {ManagedModelType, ManagedModelTypes, getModelManager} from 'models/ManagedModelDefinitions';
import {requestFetchManagedModel} from 'models/ManagedModelUtil';
import {isRegistryFolder} from 'registry/RegistryUtil';
import {useTagSchemasListingQuery} from 'schemas/useTagSchemasListingQuery';
import {toggleTagSchemaStar} from 'tag-schema/TagSchemaActions';

import {TagSchemaListingGraphQL} from '../../../../../graphql-fragments/schemas/__generated/TagSchemaListingGraphQL';

export function getOrFetchOptional<T extends keyof ManagedModelTypes>(
  modelType: T,
  key: string
): ManagedModelTypes[T] | null {
  const model = getModelManager(modelType).getModel(key);
  if (!model) {
    requestFetchManagedModel(modelType, key);
  }
  return model;
}

export interface UseTagSchemaAwareObjectCreateQueryResult {
  folder: StringIDFolder;
  tagSchemas: Array<TagSchemaListingGraphQL>;
  starredTagSchemaIds: Array<string>;
  handleToggleTagSchemaStar: (tagSchemaId: string) => void;
}

export default function useTagSchemaAwareObjectCreateQuery(
  folder: StringIDFolder | NumberIDFolder
): UseTagSchemaAwareObjectCreateQueryResult | null {
  let modifiedFolder = folder;
  const registryId = isRegistryFolder(folder) ? folder.source!.id : null;

  const result = useTagSchemasListingQuery({registryId});

  if (folder) {
    modifiedFolder = normalizeFolder(folder);
    const folderPermissions = getOrFetchOptional(ManagedModelType.PERMISSIONS_BY_ITEM_ID, modifiedFolder.id);
    if (folderPermissions) {
      modifiedFolder = {...folder, permissions: folderPermissions};
    }
  }

  if (result == null) {
    return null;
  } else {
    const {tagSchemas, starredTagSchemaIds} = result;
    return {
      folder: modifiedFolder as StringIDFolder,
      tagSchemas,
      starredTagSchemaIds,
      handleToggleTagSchemaStar: toggleTagSchemaStar,
    };
  }
}
